// extracted by mini-css-extract-plugin
export default {"side-navbar":"DashboardLayout_side-navbar__AvudK","main-content":"DashboardLayout_main-content__bcO9q"};